;(function (angular, _) {
  'use strict'

  class ComputeController {
    constructor (
      // Angular
      // Libs
      $uibModal,
      // Managers
      InvoiceLineManager, CreditNoteLineManager, ProductManager, ProductPackManager,
      // Services
      RubricService, ComputingService, LineService, PreferencesService, SnackService
      // Const
      // Resolved
    ) {
      // links
      this.$uibModal = $uibModal
      this.ComputingService = ComputingService
      this.LineService = LineService
      this.InvoiceLineManager = InvoiceLineManager
      this.CreditNoteLineManager = CreditNoteLineManager
      this.RubricService = RubricService
      this.PreferencesService = PreferencesService
      this.SnackService = SnackService
      this.companyPrefs = {}
      this.allowSubcontracts = false
      this.allowReverseCharge = false
      this.rubricService = RubricService
      this.productManager = ProductManager
      this.productPackManager = ProductPackManager
      // contain pretty rubrics (not as in db)
    }

    $onInit () {
      this.rubrics = this.rubricService.fromDbToPretty(this.parent.rubrics)
      this.update()
      this.PreferencesService.getCompanyPrefs().then((companyPrefs) => {
        this.companyPrefs = companyPrefs
        this.allowSubcontracts = _.get(companyPrefs, 'enabledFeatures.subcontracts')
        this.allowReverseCharge = this.allowSubcontracts || _.get(companyPrefs, 'enabledFeatures.reverseCharge')
      })
    }

    // is there lines or rubrics
    isThereSomething () {
      return (this.rubrics && this.rubrics.length) || (this.parent.lines && this.parent.lines.length)
    }

    dropLine (data, to, event, noMoreRubric) {
      let rubricId = _.get(event, 'srcElement.parentElement.id')
      let from = data.from
      // update rubric ref if necessary
      if (noMoreRubric) {
        this.parent.lines[from].rubric = null;
			}
      else if (rubricId) {
        this.parent.lines[from].rubric = rubricId
      } else if (this.parent.lines[to].rubric) {
        this.parent.lines[from].rubric = this.parent.lines[to].rubric
      }
      // swap lines
      this.parent.lines.splice(to, 0, this.parent.lines.splice(from, 1)[0])
      this.update()
    }

    update (line) {
      if (line && line.grant) {
        line.price.amount = line.price.amount < 0 ? line.price.amount : -line.price.amount
      }
      this.getVats()
      this.calculateRubricsTotal()
      this.theForm.$dirty = true
      this.onChange()
    }

    calculateRubricsTotal () {
      this.rubrics.forEach(r => {
        r.total = 0
        this.parent.lines.forEach(line => {
          if (line.rubric === r.rubric._id && line.type !== 'label' && line.type !== 'text') {
            if (this.containsDiscount()) {
              r.total += line.discountedTotal ? line.discountedTotal : line.total ? line.total : 0
            } else {
              r.total += line.total
            }
          }
        })
      })
    }

    editTitle (index) {
      let self = this
      return this.$uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function () { return self.parent },
          rubrics: function () { return self.rubrics },
          line: function () { return self.parent.lines[index].clone() },
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then((data) => {
              return data.map(category => category.label)
            })
          }]
        },
        templateUrl: '/app/modules/compute/category/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        self.parent.lines[index] = line
      })
    }

    editText (index) {
      let self = this
      return this.$uibModal.open({
        controllerAs: 'addtext',
        bindToController: true,
        resolve: {
          invoice: function () { return self.parent },
          type: () => { return this.case },
          line: function () { return self.parent.lines[index].clone() },
        },
        templateUrl: '/app/modules/compute/text/add-text.template.html',
        controller: 'AddTextController'
      }).result.then(function ({ label, title }) {
        const l = self.parent.lines[index]
        l.label = label
        l.title = title
        self.theForm.$dirty = true
      })
    }

    removeLine (index) {
      this.parent.lines.splice(index, 1)
      this.update()
    }

    addText () {
      return this.$uibModal.open({
        controllerAs: 'addtext',
        bindToController: true,
        resolve: {
          invoice: () => { return this.parent },
          type: () => { return this.case },
          line: angular.noop,
        },
        templateUrl: '/app/modules/compute/text/add-text.template.html',
        controller: 'AddTextController'
      }).result.then((line) => {
        this.parent.lines = this.parent.lines || []
        this.parent.lines.push(line)
        this.update()
      })
    }

    addSpace () {
      let space
      if (!this.parent.lines) {
        this.parent.lines = []
      }
      switch (this.case) {
        case 'invoice':
        case 'quote':
          space = this.InvoiceLineManager.create({
            type: 'label',
            rubric: _.get(this, 'rubric.rubric._id', undefined),
            options: {
              type: 'space'
            }
          })
          break
        case 'creditNote':
          space = this.CreditNoteLineManager.create({
            type: 'label',
            rubric: _.get(this, 'rubric.rubric._id', undefined),
            options: {
              type: 'space'
            }
          })
          break
        default:
          return
      }
      this.parent.lines.push(space)
      this.update()
    }

    editLine (index, truc) {
      const copy = this.parent.lines[index].clone()
      copy.productType = this.parent.lines[index].productType
      return this.LineService.promptLineEdit(this.parent, copy, truc, this.case, undefined,true)
        .then((res) => {
          res.line.shouldRecompute = true
          if (res.category) {
            var i = _.findIndex(this.parent.lines, { 'label': res.category.label })
            if (i >= 0) {
              if (index > i) {
                i++
              }
              this.parent.lines[index] = res.line
              this.parent.lines.splice(i, 0, self.invoice.lines.splice(index, 1)[0])
            } else {
              this.parent.lines.splice(index, 1)
              this.parent.lines.push(res.category)
              this.parent.lines.push(res.line)
            }
          } else {
            this.parent.lines[index] = res.line
            if(res.rubric == undefined){
              var rubric = copy.rubric
              res.rubric = rubric
            }
            if (res.saveModification) {
              this.productManager.findById(res.line.product).then((product) => {
                product.description = res.line.description
                product.VAT = res.line.VAT
                product.label = res.line.label
                product.reference = res.line.reference
                product.price = {
                  VAT: res.line.VAT * 100,
                  amount: res.line.price.amount,
                  currency: res.line.price.currency,
                }
                product.unit = res.line.unit
                product.category = res.line.category
                product.type = res.line.productType?._id || res.line.productType
                product.save().then(() => {
                  this.SnackService.snack({
                    text: 'Produit modifié !',
                    delay: 3000
                  })
                  this.update()
                })
              })
            } else {
              this.update()
            }
          }
          if (res.editSubcontract) {
            this.editSubcontract(res.line)
          }
        })
    }

    editProductType (index) {
      return this.LineService.promptLineProductTypeEdit()
        .then((productType) => {
          this.parent.lines[index].productType = productType
          this.update()
          this.SnackService.snack({
            text: 'Type de produit modifié !',
            delay: 3000
          })
        })
    }

    duplicateLine (index) {
      this.parent.lines.splice(index + 1, 0, this.parent.lines[index].clone())
      this.parent.lines[index + 1].shouldRecompute = true
      this.update()
    }

    lineToFlateRate (index) {
      var l = this.parent.lines[index]
      l.unit = 'Forfait'
      l.price.amount = l.total
      l.quantity = 1
      this.update()
    }

    _rubricExist (id) {
      return this.rubrics.map(e => e.rubric._id).includes(id)
    }

    addRubric () {
      return this.$uibModal
        .open({
          component: 'addRubric',
          backdrop : 'static',
          resolve: {
            rubrics: () => angular.copy(this.rubrics)
          }
        })
        .result.then((rubrics) => {
          this.rubrics = rubrics
          this.parent.rubrics = this.RubricService.fromPrettyToDb(rubrics)
          if(!this.parent.lines){
            this.parent.lines = []
          }
          // si on supprime une rubrique, on réinitialise le produit sans rubrique
          this.parent.lines.forEach((line, i) => {
            if (line.rubric && line.rubric.length && !this._rubricExist(line.rubric)) {
              line.rubric = null
            }
          })
          this.update()
        })
    }

    addTitle (index) {
      return this.$uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: () => { return this.parent },
          line: angular.noop,
          rubrics: () => { return this.rubrics },
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then((data) => {
              return data.map(category => category.label)
            })
          }]
        },
        templateUrl: '/app/modules/compute/category/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then((line) => {
        this.parent.lines = this.parent.lines || []
        this.parent.lines.push(line)
        this.update()
      })
    }

    addText () {
      return this.$uibModal.open({
        controllerAs: 'addtext',
        bindToController: true,
        resolve: {
          invoice: () => { return this.parent },
          type: () => { return this.case },
          line: angular.noop,
        },
        templateUrl: '/app/modules/compute/text/add-text.template.html',
        controller: 'AddTextController'
      }).result.then((line) => {
        this.parent.lines = this.parent.lines || []
        this.parent.lines.push(line)
        this.update()
      })
    }

    addLine (index) {
      return this.LineService.promptLineCreate(this.parent, this.case, this.rubrics, true)
        .then((res) => {
          res.line = this.InvoiceLineManager.create(res.line)
          res.line.shouldRecompute = true
          res.line.type = 'simple_line'
          this.parent.lines = this.parent.lines || []
          if (res.category) {
            var i = _.findIndex(this.parent.lines, { 'label': res.category.label })
            if (i >= 0) {
              this.parent.lines.splice(i + 1, 0, res.line)
            } else {
              this.parent.lines.push(res.category)
              this.parent.lines.push(res.line)
            }
          } else if (!isNaN(index)) {
            this.parent.lines.splice(index + 1, 0, res.line)
          } else {
            this.parent.lines.push(res.line)
            if (res.saveModification) {
              this.productManager.findById(res.line.product).then((product) => {
                product.description = res.line.description
                product.VAT = res.line.VAT
                product.label = res.line.label
                product.reference = res.line.reference
                product.price = {
                  VAT: res.line.VAT * 100,
                  amount: res.line.price.amount,
                  currency: res.line.price.currency,
                }
                product.unit = res.line.unit
                product.category = res.line.category
                product.type = res.line.productType?._id || res.line.productType
                product.save().then(() => {
                  this.SnackService.snack({
                    text: 'Produit modifié !',
                    delay: 3000
                  })
                  this.update()
                })
              })
            } else {
              this.update()
            }
          }
          if (res.editSubcontract) {
            this.editSubcontract(res.line)
          }
        })
    }
    addLineGrant (index) {
      return this.LineService.prompteLineCreateGrant(this.parent, this.case, this.rubrics, true)
        .then((res) => {
          res.line = this.InvoiceLineManager.create(res.line)
          res.line.shouldRecompute = true
          res.line.type = 'simple_line'
          this.parent.lines = this.parent.lines || []
          if (res.category) {
            var i = _.findIndex(this.parent.lines, { 'label': res.category.label })
            if (i >= 0) {
              this.parent.lines.splice(i + 1, 0, res.line)
            } else {
              this.parent.lines.push(res.category)
              this.parent.lines.push(res.line)
            }
          } else if (!isNaN(index)) {
            this.parent.lines.splice(index + 1, 0, res.line)
          } else {
            this.parent.lines.push(res.line)
            this.update()
          }
          if (res.editSubcontract) {
            this.editSubcontract(res.line)
          }
        })
    }

    containsDiscount () {
      return this.ComputingService.containsDiscount(this.parent)
    }

    // determine if we print a total or not (more than one line)
    doesRubricHasLine (_id) {
      let answer = 0
      if(!this.parent.lines) {
        this.parent.lines = []
      }
      this.parent.lines.forEach(line => {
        if (line.rubric === _id && line.type !== 'label') answer++
      })
      return answer > 1
    }

    editSubcontract (line) {
      return this.$uibModal.open({
        component: 'editSubcontractModal',
        size: 'xl',
        resolve: {
          line: [() => {
            return angular.copy(line)
          }]
        }
      }).result.then((result) => {
        line.subcontracts = result.subcontracts
        this.update()
      })
    }

    isNotCreditNote () {
      return this.case !== 'creditNote'
    }

    check(line) {
      if (line.grant && this.parent.type === 'deposit') {
        return false
      }
      return !line.rubric | line.rubric === ''
    }

    getRubricColspan () {
      let base = this.containsDiscount() ?  9 : 7
      return base - (this.allowReverseCharge ? 0 : 1)
    }

    getMinPrice (index) {
      let l = this.parent.lines[index]
      if (!l.subcontracts?.length) {
        return null
      }
      return l.subcontracts.reduce((acc, s) => {
        return acc + s.price
      }, 0)
    }

    addProductPack () {
      const self = this
      return this.$uibModal.open({
        controllerAs: 'modal',
        bindToController: true,
        size: 'lg',
        templateUrl: '/app/modules/compute/product-pack/add-product-pack.template.html',
        controller: ['$uibModalInstance', 'ProductPackManager', function ($uibModalInstance, ProductPackManager) {
          var modal = this
          modal.results = []
          modal.selectedPack = null
          modal.lines = []

          modal.search = function (term) {
            load(term)
          }

          modal.selectPack = function (pack) {
            modal.lines = pack.products.map(function (item) {
              return { product: item.product, quantity: item.quantity }
            })
          }

          modal.removeLine = function (index) {
            modal.lines.splice(index, 1)
          }

          modal.confirm = function () {
            $uibModalInstance.close({
              label: modal.selectedPack.label,
              products: modal.lines
            })
          }

          modal.cancel = function () {
            $uibModalInstance.dismiss('cancel')
          }

          function load (term) {
            var query = ProductPackManager
              .query({ populate: 'products.product' })
              .fields('label products')
              .limit(10)
            if (term && term.length >= 2) {
              query.search(term, 'label')
            }
            return ProductPackManager.get(query).then(function (data) {
              modal.results = data.data
            })
          }

          load(null)
        }]
      }).result.then(function (productPack) {
        if (!productPack || !productPack.products || !productPack.products.length) return

        // Créer la rubrique à partir du label du pack
        const rubricId = window.UUID.genV4().toString()
        const topLevelCount = self.rubrics.filter(function (r) { return r.deep === 0 }).length
        self.rubrics.push({
          deep: 0,
          label: String(topLevelCount + 1),
          rubric: {
            _id: rubricId,
            label: productPack.label,
            parent: null,
            position: topLevelCount
          }
        })
        self.parent.rubrics = self.RubricService.fromPrettyToDb(self.rubrics)

        // Créer une ligne par produit du pack
        self.parent.lines = self.parent.lines || []
        const Manager = self.case === 'creditNote' ? self.CreditNoteLineManager : self.InvoiceLineManager

        productPack.products.forEach(function (item) {
          const product = item.product
          if (!product) return
          const line = Manager.create({
            label: product.label,
            description: product.description || '',
            reference: product.reference || '',
            price: {
              amount: _.get(product, 'price.amount', 0),
              currency: _.get(product, 'price.currency', 'EUR')
            },
            quantity: item.quantity || 1,
            unit: product.unit || '',
            VAT: product.VAT || 0,
            product: product._id,
            rubric: rubricId,
            type: 'simple_line'
          })
          line.shouldRecompute = true
          self.parent.lines.push(line)
        })

        self.update()
      })
    }
  }

  ComputeController.$inject = [
    // Angular
    // Libs
    '$uibModal',
    // Managers
    'InvoiceLineManager', 'CreditNoteLineManager', 'ProductManager', 'ProductPackManager',
    // Services
    'RubricService', 'ComputingService', 'LineService', 'PreferencesService', 'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('compute', {
      bindings: {
        case: '=',
        parent: '=',
        editable: '=',
        vats: '=',
        theForm: '=',
        getVats: '&',
        onChange: '&'
      },
      templateUrl: '/app/modules/compute/compute.template.html',
      controller: ComputeController
    })
})(window.angular, window._)
